// extracted by mini-css-extract-plugin
module.exports = {"heading":"_1Qi9aAs3H2Oifs79w4NQ2l"};